import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth-service.interface';
import { AUTH_SERVICE, PROTECTED_FALLBACK_PAGE_URI } from './tokens';

@Injectable({
  providedIn: 'root',
})
export class ProtectedGuard implements CanActivate, CanActivateChild {
  constructor(
    @Inject(AUTH_SERVICE) private authService: AuthService,
    @Inject(PROTECTED_FALLBACK_PAGE_URI)
    private protectedFallbackPageUri: string,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authService.isAuthorized().pipe(
      map((isAuthorized) => {
        if (!isAuthorized && this.protectedFallbackPageUri) {
          this.authService.setInterruptedUrl(state.url);
          return this.router.parseUrl(this.protectedFallbackPageUri);
        }

        return isAuthorized;
      })
    );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
